import React from 'react';
import './Portfolio.css';
import data from '../../data';

const Portfolio = () => {
  return (
    <section id='portfolio'>
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {data.map(({ id, image, title, github, demo }) => {
          return (
            <article key={id} className="portfolio__item">
              <div className="portfolio__item-img">
                <img src={image} alt={title} />
              </div>
              <h3>{title}</h3>
              <div className="portfolio__cta">
                <a href={demo} target="_blank" className='btn' rel="noreferrer">Live Demo</a>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  )
}

export default Portfolio
